import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { reportClientError } from './lib/clientTelemetry';

document.documentElement.lang = "es";
document.documentElement.setAttribute("translate", "no");
document.documentElement.classList.add("notranslate");
document.body?.setAttribute("translate", "no");
document.body?.classList.add("notranslate");

window.addEventListener('error', (event) => {
  reportClientError(event.error || event.message, { source: 'window-error' });
});
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason instanceof Error ? event.reason : new Error(String(event.reason || 'Promesa rechazada'));
  reportClientError(reason, { source: 'unhandled-rejection' });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// La PWA solo conserva la estructura publica de la aplicacion. Las API,
// documentos, credenciales y datos operativos nunca se almacenan en cache.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", { scope: "/", updateViaCache: "none" }).then((registration) => {
      const update = () => registration.update().catch(() => {});
      window.setInterval(update, 5 * 60 * 1000);
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') update(); });
      window.addEventListener('pageshow', update);
      window.addEventListener('focus', update);
      update();
    }).catch(() => {
      // La aplicacion web debe seguir funcionando aunque el navegador no admita PWA.
    });
  });
}
